module.exports = __webpack_public_path__ + "static/media/Silestone-Flash-Promo-Digital-Flyer-USA.ce682a6d.pdf";